
import { Injectable } from '@angular/core';
import { TaskOperation } from 'src/app/models/interface/tasks/taskOperationsResponse';
import { TaskOperationDto } from 'src/app/models/tasks/task-operation/task-operation-dto';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { Converter } from '../../converter.interface';

@Injectable({
    providedIn: 'root'
})
export class TaskOperationConverter implements Converter<TaskOperationDto> {
    convert(input: TaskOperation): TaskOperationDto {
        return new TaskOperationDto(StringUtils.default(input.operationType), 
            new Date(StringUtils.valueOrDefault(input.executionDate, input.creationDate)), 
            new Date(input.creationDate), StringUtils.default(input.status.value), 
            StringUtils.default(input.taskOperationActionType), input.characteristics, 
            StringUtils.default(input.comment), StringUtils.default(input.userId),
            StringUtils.default(input.description),StringUtils.default(input.errorCode), 
            StringUtils.default(input.activity));
    }
}
